import React, { Component } from "react";
import { RouteInfo } from "./templates";

const TEMPLATES = {
    routeInfo: RouteInfo,
};

export default class MapHeader extends Component {
    render() {
        const { name, ...props } = this.props;
        const CurrentHeader = TEMPLATES[name];

        return CurrentHeader ? <CurrentHeader {...props} /> : null;
    }
}
